
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Heart } from "lucide-react";
import { User } from "@supabase/supabase-js";
import { useLazyImage } from "@/hooks/useLazyImage";

interface VacationImageProps {
  vacation: any;
  user: User | null;
  isFavorite: boolean;
  onFavoriteToggle: () => void;
  isTogglingFavorite: boolean;
}

export const VacationImage = ({ 
  vacation, 
  user, 
  isFavorite, 
  onFavoriteToggle, 
  isTogglingFavorite 
}: VacationImageProps) => {
  const vacationName = vacation.name || vacation.title || "Onbekende vakantie";
  const imageUrl = vacation.imageURL || vacation.image || "/placeholder.svg";
  const { imageSrc, isLoaded, imgRef } = useLazyImage({ 
    src: imageUrl, 
    placeholder: "/placeholder.svg" 
  });

  return (
    <div className="relative">
      <img
        ref={imgRef}
        src={imageSrc}
        alt={vacationName}
        className={`w-full h-48 object-cover group-hover:scale-105 transition-all duration-300 ${
          !isLoaded ? 'blur-sm' : 'blur-0'
        }`}
        loading="lazy"
        onError={(e) => {
          (e.target as HTMLImageElement).src = "/placeholder.svg";
        }}
      />
      {!isLoaded && (
        <div className="absolute inset-0 bg-gray-200 animate-pulse" />
      )}
      {/* Show heart button for all users (logged in or not) */}
      <Button
        variant="outline"
        size="icon"
        className={`absolute top-2 right-2 bg-white/90 hover:bg-white ${
          isFavorite ? "text-red-500" : "text-gray-500"
        }`}
        onClick={onFavoriteToggle}
        disabled={isTogglingFavorite}
        title={user ? "Favoriet" : "Toevoegen aan tijdelijke favorieten"}
      >
        <Heart className={`h-4 w-4 ${isFavorite ? "fill-current" : ""}`} />
      </Button>
      {vacation.lastMinute === 'Yes' && (
        <Badge className="absolute top-2 left-2 bg-red-500 text-white">
          Last Minute
        </Badge>
      )}
    </div>
  );
};
